import React from 'react';
import Counter from './counter';

const CounterSection2 = ({backgroundImage}) => {
    return ( 
    <div className="section-full content-inner-2 overlay-black-middle bg-img-fix" style={{ 
        backgroundImage: "url(" + backgroundImage + ")",
        padding: "100px 0",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center"
    }}>
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-12 m-b30 wow fadeInLeft" data-wow-duration="2s" data-wow-delay="0.3s">
                    <div className="counter-style-premium text-center text-white">
                        <div className="counter-num">
                            <Counter count={1000}/><span className="counter-plus">+</span>
                        </div>
                        <h5 className="counter-label">Precision Projects</h5>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-12 m-b30 wow fadeInDown" data-wow-duration="2s" data-wow-delay="0.3s">
                    <div className="counter-style-premium text-center text-white">
                        <div className="counter-num">
                            <Counter count={250}/><span className="counter-plus">+</span>
                        </div>
                        <h5 className="counter-label">Global Partners</h5>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-12 m-b30 wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.3s">
                    <div className="counter-style-premium text-center text-white">
                        <div className="counter-num">
                            <Counter count={50}/><span className="counter-plus">+</span>
                        </div>
                        <h5 className="counter-label">Expert Engineers</h5>
                    </div>
                </div>
            </div>
        </div>

        <style dangerouslySetInnerHTML={{ __html: `
            .counter-style-premium {
                padding: 20px;
            }
            .counter-num {
                font-size: 8rem !important;
                font-weight: 900 !important;
                line-height: 0.8 !important;
                margin-bottom: 25px;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                color: #ffffff !important;
                text-shadow: 0 15px 45px rgba(0,0,0,0.6);
                letter-spacing: -4px;
            }
            .counter-plus {
                font-size: 2.5rem !important;
                font-weight: 700 !important;
                margin-top: 10px;
                margin-left: 2px;
                color: var(--brand-orange) !important;
                opacity: 1 !important;
            }
            .counter-num span.counter-value {
                font-size: inherit !important;
                font-weight: inherit !important;
            }
            .counter-label {
                font-size: 19px !important;
                font-weight: 800 !important;
                text-transform: uppercase !important;
                letter-spacing: 4px !important;
                color: #ffffff;
                margin: 0;
            }
            @media (max-width: 1200px) {
                .counter-num { font-size: 6rem !important; }
            }
            @media (max-width: 767px) {
                .counter-num { font-size: 4.5rem !important; }
                .counter-plus { font-size: 1.8rem !important; margin-top: 5px; }
            }
        `}} />
    </div>
    );
}
 
export default CounterSection2;